import { AppHeader } from 'components/AppHeader';
import { LoginModalForm } from 'components/LoginModalForm';
import { NavigationMenu } from 'components/NavigationMenu';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch } from 'react-redux';
import { sessionClose } from 'store/reducers/authReducer';
import { Container } from 'ui/Container';
import { MainWrapper } from './style';

function AppLayout({ children }) {
  const dispatch = useDispatch();

  const onIdle = async () => {
    dispatch(sessionClose());
  };

  useIdleTimer({
    onIdle,
    timeout: 1800000,
    throttle: 500,
    crossTab: true,
    syncTimers: 200,
  });

  return (
    <MainWrapper>
      <NavigationMenu />

      <div id="main-wrapper" className="content-wrapper">
        <AppHeader />
        <main>
          <LoginModalForm />
          <Container>{children}</Container>
        </main>
      </div>
    </MainWrapper>
  );
}

export { AppLayout };
